export default {
  title: 'Estimator24 — serviciu de evaluare imobiliară',
  description: 'Analiză precisă a prețurilor, evaluare cu inteligență artificială și prognoza dinamicii pieței',
  login: 'Autentificare în contul personal'
}
